import { render, staticRenderFns } from "./quiz-games.html?vue&type=template&id=363e561e&scoped=true&external"
import script from "./quiz-games.js?vue&type=script&lang=js&external"
export * from "./quiz-games.js?vue&type=script&lang=js&external"
import style0 from "./quiz-games.scss?vue&type=style&index=0&id=363e561e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e561e",
  null
  
)

export default component.exports